const authApi = '/auth';

export const userProfile = () => `${authApi}/profile`;
export const authUser = () => `${authApi}`;
export const authPositionSubscriptionUser = () =>
  `${authApi}/subscription-token`;
export const logout = () => `${authApi}/logout`;
